<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <ValidationObserver ref="deactivationForm" v-else>
            <div class="col-lg-12 mb-4">
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl-wrap mb-3">
                            <div class="box-ttl">
                                Deactivating employee : {{user.name}} {{user.last_name}}
                            </div>
                        </div>
                        <div class="center-separated-block">
                            <div class="left-block">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Why are you deactivating this
                                                employee?</label>
                                            <select class="custom-select" v-model="form.deactivating_reason"
                                                    @change="handleSelectChange">
                                                <option value="selectOne" disabled>Select One</option>
                                                <option
                                                    v-for="option in deactivatingOptions"
                                                    :value="option"
                                                >
                                                    {{ option }}
                                                </option>
                                                <option value="null">Other</option>
                                            </select>
                                        </div>
                                        <div class="form-group form-group-1" v-if="form.deactivating_reason === null">
                                            <input type="text" class="form-control" v-model="form.deactivating_reason_other">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <p>
                                            <b>Reminders</b> <br/>
                                            Please ensure document is complete (If applicable, resignation uploaded to
                                            their profile)
                                        </p>
                                        <p>
                                            If uniform has not been returned yet, notify payroll department to remove
                                            the employee from direct deposit before their final check
                                        </p>
                                        <p>
                                            If this person’s schedule need to be added to the shift board, please add.
                                        </p>
                                    </div>
                                    <ValidationProvider
                                        class="col-md-8"
                                        name="Date"
                                        rules="required"
                                        v-slot="{errors}"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Last Date of Work</label>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group form-group-1 mb-0">
                                                        <input type="date"
                                                               class="form-control"
                                                               v-model="form.last_date_work">
                                                        <FormError :error="errors[0]" name="Date"></FormError>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ValidationProvider>
                                    <div class="col-12">
                                        <p>Please note that the user will be blacked out 5 days following the last
                                            date</p>
                                    </div>
                                    <div class="col-12 mt-5">
                                        <div class="btns-wrap">
                                            <a
                                               :href="`/master-admin/applicants/${applicantId}/show`"
                                                class="btn btn--outline-primary"
                                            >
                                                Cancel
                                            </a>
                                            <button
                                                class="btn btn--secondary"
                                                @click="submitForm"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sep-line"></div>
                            <div v-if="loading" class="lds-dual-ring"></div>
                            <div class="small-block" v-else>
                                <label for="" class="form-label">Optional Actions</label>
                                <button
                                    :disabled="disableInterviewButton"
                                    class="btn btn--outline-primary btn--middle w-100 mb-4"
                                    @click="sendExitInterview"
                                >Send Exit Interview</button>

                                <p v-if="showInterviewDetails">Exit Interview emailed on
                                    {{ calculateDate(exitInterviewDetails.created_at)}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>

    </div>
</template>

<script>
import DeactivationServices from "../services/DeactivationServices";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import CommonService from "../../../../AppUser/resources/js/services/CommonService";
import ApplicantsServices from "../services/ApplicantsServices";

export default {
    name: 'DeactivationPage',
    mixins: [DateConverter, ModalHandler],
    props: {
        applicantId: Number
    },
    data() {
        return {
            user: null,
            loading: true,
            status_history_id: null,
            disableInterviewButton: true,
            showInterviewDetails: false,
            exitInterviewDetails: null,
            deactivatingOptions: [
                'This person resigned',
                'This person was terminated for cause',
                'This person is inactive',
                'This person disappeared',
                'No openings',
            ],
            form: {
                deactivating_reason: 'selectOne',
                deactivating_reason_other: null,
                last_date_work: null
            }
        }
    },
    methods: {
        handleSelectChange() {
            if (this.form.deactivating_reason === "null") {
                this.form.deactivating_reason = null;
            }
        },

        async submitForm() {
            this.$showLoadingMessage()
            const valid = await this.$refs.deactivationForm.validate();
            if (!valid) {
                this.$showValidationErrorMessage('Error!', 'You forgot to specify the reason or date');
                return;
            }
            try {
                const response = await DeactivationServices.deactivateApplicant(this.applicantId, this.form)
                this.$showSuccessMessage('User has been deactivated');
                this.status_history_id = response.data.history_id
                this.disableInterviewButton = false
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your form was not submitted. Please try again later.')
            }
        },
        async sendExitInterview() {
            this.$showLoadingMessage()
            try {
                const { data: response } = await DeactivationServices.sendInterview(this.applicantId,this.status_history_id)
                this.$showSuccessMessage('Exit Interview has been sent');
                this.showInterviewDetails = true
                this.exitInterviewDetails = response
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Exit Interview was not sent. Please try again')
            }
        },
        async getUserInfo() {
            try {
                const { data: response } = await ApplicantsServices.getUserInfo(this.applicantId)
                this.user = response
                this.loading = false
            } catch (e) {

            }
        }
    },
    mounted() {
        this.getUserInfo()
    }

}

</script>

<style scoped>

</style>
